import { Poly } from "../../../engine/Poly";
import { DRACOLoader } from "../../../modules/three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "../../../modules/three/examples/jsm/loaders/GLTFLoader";
import { CoreBaseLoader } from "../_Base";
import { BaseGeoLoaderHandler } from "./_BaseLoaderHandler";
export class GLTFLoaderHandler extends BaseGeoLoaderHandler {
  reset() {
    var _a;
    super.reset();
    (_a = this._dracoLoader) == null ? void 0 : _a.dispose();
    this._gltfLoader = void 0;
    this._gltfdracoLoader = void 0;
    this._dracoLoader = void 0;
  }
  async load(options) {
    return super.load(options);
  }
  async _getLoader(options) {
    if (options.draco) {
      return this._gltfdracoLoader = this._gltfdracoLoader || await this._createGLTFLoaderWithDRACO(options);
    } else {
      return this._gltfLoader = this._gltfLoader || await this._createGLTFLoader(options);
    }
  }
  _createGLTFLoader(options) {
    return new GLTFLoader(this.loadingManager);
  }
  async _createGLTFLoaderWithDRACO(options) {
    const loader = new GLTFLoader(this.loadingManager);
    await this._setupDRACO(loader, options);
    return loader;
  }
  async _setupDRACO(gltfLoader, options) {
    this._dracoLoader = this._dracoLoader || await this._createDRACOLoader(options);
    gltfLoader.setDRACOLoader(this._dracoLoader);
  }
  async _createDRACOLoader(options) {
    const useJS = false;
    const node = options.node;
    const dracoLoader = new DRACOLoader(this.loadingManager);
    const root = Poly.libs.root();
    const DRACOGLTFPath = Poly.libs.DRACOGLTFPath();
    if (root || DRACOGLTFPath) {
      const decoderPath = `${root || ""}${DRACOGLTFPath || ""}/`;
      const files = useJS ? ["draco_decoder.js"] : ["draco_decoder.wasm", "draco_wasm_wrapper.js"];
      await CoreBaseLoader._loadMultipleBlobGlobal({
        files: files.map((file) => {
          return {
            fullUrl: `${decoderPath}${file}`
          };
        }),
        node,
        error: "failed to load draco libraries. Make sure to install them to load .glb files"
      });
      dracoLoader.setDecoderPath(decoderPath);
    } else {
      dracoLoader.setDecoderPath(void 0);
    }
    dracoLoader.setDecoderConfig({ type: useJS ? "js" : "wasm" });
    dracoLoader.preload();
    return dracoLoader;
  }
  _onLoadSuccessGLTF(gltf) {
    const scene = gltf.scene || gltf.scenes[0];
    scene.animations = gltf.animations;
    return [scene];
  }
}
